import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { AfterSaleBookingContext } from "../Context/AfterSaleBookingContext";

class AfterSaleBookingInit extends StepFlow {
    get stepName() { return "AfterSaleBookingInit_Step"; }

    async onEventSetup(): Promise<void> {
    }

    async onExecute(): Promise<void> {
        console.log("After Sale Booking Init Step Executed.....");
        this.setCtx("afterSaleBookingContext", AfterSaleBookingContext)
        const context = this.getCtx<AfterSaleBookingContext>("afterSaleBookingContext")!;

        context.routeTo = ["UpcomingPastBookingFlow"];
        this.next();
    }
}

export const afterSaleBookingInitStepDeclaration = new StepDefinition({
    stepName: "AfterSaleBookingInit_Step",
    stepClass: AfterSaleBookingInit
});